export default "__VITE_ASSET__DTjwUPlN__"